import { Model, Attr, HasMany } from 'spraypaint';
import { Lot } from '../';
import ApplicationRecord from '../ApplicationRecord';

@Model()
export default class LotVolumeGraph extends ApplicationRecord {
  static jsonapiType = 'lot-volume-graphs';

  static listHeaders() {
    return [
      {
        text: 'ID',
        value: 'id',
        width: 100,
        sortable: false,
      },
    ];
  }

  static scopeFactory() {
    return LotVolumeGraph.includes([]);
  }

  @Attr() startDatetime: string;
  @Attr() endDatetime: string;
  @Attr() labels: [];
  @Attr() values: { indoor: []; outdoor: [] };
  @Attr() fillRates: { indoor: []; outdoor: [] };

  @HasMany() lots: Lot[];
}
